<template>
  <b-form @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.id)">
    <div class="row">
      <div class="col">
        <b-card>
          <template #header>
            <b>Upload Public Holiday CSV</b>
          </template>

          <div>
            <b class="mb-2 d-block">CSV File Format</b>
            <ul>
              <li>Each row should have three columns: name, state and date</li>
              <li>Name: max length 128</li>
              <li>State: short state name (e.g. VIC, NSW, etc.)</li>
              <li>Date: in YYYY-MM-DD format</li>
            </ul>
            <button class="btn btn-primary mb-2" @click.prevent="downloadExample">
              Download An Example CSV
            </button>
          </div>

          <b-form-file
            v-model="form.file"
            accept=".csv"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
          />

          <div v-if="errors && errors.length">
            <b-alert show variant="warning" class="mt-3">
              <b class="mb-2 d-block">Upload completed with the following notice(s):</b>

              <div v-for="error in errors" :key="error">
                {{ error }}
              </div>
            </b-alert>
          </div>

          <div v-if="created && created.length" class="mt-4">
            <table class="table table-striped table-bordered table-hover">
              <tr>
                <th>Name</th>
                <th>State</th>
                <th>Date</th>
              </tr>
              <tr v-for="(entry, index) in created" :key="index">
                <td>{{ entry.name }}</td>
                <td>{{ entry.state }}</td>
                <td>{{ entry.date }}</td>
              </tr>
            </table>
          </div>
        </b-card>
      </div>
    </div>

    <b-card-footer class="mb-5">
      <div class="row">
        <div class="col text-right">
          <button class="btn btn-primary" :disabled="form.notReady()">
            <font-awesome-icon v-if="form.busy" spin :icon="['fal', 'spinner']" />
            <font-awesome-icon v-else :icon="['fal', 'cloud-upload']" />
            Upload
          </button>
        </div>
      </div>
    </b-card-footer>
  </b-form>
</template>

<script type="text/babel">
import file from "@/imports/file";

export default {
  data() {
    return {
      created: [],
      errors: [],
      crud: null,
      form: new window.AppForm({
        file: null,
      }),
    };
  },

  created() {
    this.init();
  },

  methods: {
    init() {
      this.crud = new window.AppCrud("public-holidays");

      this.form.reset();
    },

    onSubmit() {
      this.crud.submit(this.form, "upload").then((response) => {
        if (response.errors) {
          this.errors = response.errors;
        }

        this.created = response.created;
        window.toastr.success("Public Holidays Uploaded!", "Success");
      });
    },

    downloadExample() {
      file.download(
        "New Year's Day,NATIONAL,2025-01-01\nMelbourne Cup,VIC,2025-11-04",
        "example.csv"
      );
    },
  },
};
</script>
